import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=2ac67f08&scoped=true"
import script from "./Popover.vue?vue&type=script&lang=ts"
export * from "./Popover.vue?vue&type=script&lang=ts"
import style0 from "./Popover.vue?vue&type=style&index=0&id=2ac67f08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac67f08",
  null
  
)

export default component.exports